import { FC } from "react";
import { TileLayer } from "react-leaflet";
import { usePreferences } from "../../../../../hooks/usePreferences";

interface Props {
	provider: "heremaps";
}

/**
 * Returns a TileLayer configuret to work with the specified provider.
 * MUST be used inside a Map or MapContainer component
 * @param provider provider of the tile layer
 * @returns
 */
const TileProviderLayer: FC<Props> = ({ provider }) => {
	const { preferences } = usePreferences();

	let lang = preferences.language || "en";
	let accessToken = import.meta.env.VITE_HERE_APIKEY || "";
	// let style =
	// 	preferences.theme === "light" // Did user specify color mode?
	// 		? "lite.day"
	// 		: preferences.theme === "dark"
	// 			? "lite.night"
	// 			: preferences.systemTheme === "light"
	// 				? "lite.night"
	// 				: "line.day";
	let style = "lite.day";
	let providerUrl = `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/jpeg?size=512&apikey=${accessToken}&style=${style}&lang=${lang}&lang2=${lang}`;

	return <TileLayer url={providerUrl} />;
};

export default TileProviderLayer;
